var map = {
	"./GooglemapImage.png": "./src/assets/GooglemapImage.png",
	"./Services/services1.jpg": "./src/assets/Services/services1.jpg",
	"./Services/services2.jpg": "./src/assets/Services/services2.jpg",
	"./Services/services3.jpg": "./src/assets/Services/services3.jpg",
	"./Services/services4.jpeg": "./src/assets/Services/services4.jpeg",
	"./Services/services5.jpg": "./src/assets/Services/services5.jpg",
	"./Services/services6.jpg": "./src/assets/Services/services6.jpg",
	"./about.jpg": "./src/assets/about.jpg",
	"./aerial-service-1.jpg": "./src/assets/aerial-service-1.jpg",
	"./aerial-service-1a.jpg": "./src/assets/aerial-service-1a.jpg",
	"./aerial-service-1b.jpg": "./src/assets/aerial-service-1b.jpg",
	"./aerial-service-2.jpg": "./src/assets/aerial-service-2.jpg",
	"./aerial-service-3.jpg": "./src/assets/aerial-service-3.jpg",
	"./aerial-service-4.jpg": "./src/assets/aerial-service-4.jpg",
	"./agri-service-1.jpg": "./src/assets/agri-service-1.jpg",
	"./agri-service-2.jpg": "./src/assets/agri-service-2.jpg",
	"./agri-service-3.jpg": "./src/assets/agri-service-3.jpg",
	"./agri-service-4.jpg": "./src/assets/agri-service-4.jpg",
	"./agri-service-5.jpg": "./src/assets/agri-service-5.jpg",
	"./background.jpg": "./src/assets/background.jpg",
	"./bg-1.jpg": "./src/assets/bg-1.jpg",
	"./call icon.png": "./src/assets/call icon.png",
	"./construction-service-1.jpg": "./src/assets/construction-service-1.jpg",
	"./construction-service-2.jpg": "./src/assets/construction-service-2.jpg",
	"./construction-service-3.jpg": "./src/assets/construction-service-3.jpg",
	"./construction-service-4.jpg": "./src/assets/construction-service-4.jpg",
	"./contact-phone-icon.svg": "./src/assets/contact-phone-icon.svg",
	"./drone.png": "./src/assets/drone.png",
	"./email.svg": "./src/assets/email.svg",
	"./image4.jpg": "./src/assets/image4.jpg",
	"./industrial-service-1.jpg": "./src/assets/industrial-service-1.jpg",
	"./industrial-service-2.jpg": "./src/assets/industrial-service-2.jpg",
	"./industrial-service-3.jpg": "./src/assets/industrial-service-3.jpg",
	"./logo.png": "./src/assets/logo.png",
	"./m2r2-logo.png": "./src/assets/m2r2-logo.png",
	"./mapping-service-1.jpg": "./src/assets/mapping-service-1.jpg",
	"./mapping-service-2.jpg": "./src/assets/mapping-service-2.jpg",
	"./mapping-service-3.webp": "./src/assets/mapping-service-3.webp",
	"./mapping-service-4.jpg": "./src/assets/mapping-service-4.jpg",
	"./portfolios/aerialportfolio/image1.jpg": "./src/assets/portfolios/aerialportfolio/image1.jpg",
	"./portfolios/aerialportfolio/image10.jpg": "./src/assets/portfolios/aerialportfolio/image10.jpg",
	"./portfolios/aerialportfolio/image11.jpg": "./src/assets/portfolios/aerialportfolio/image11.jpg",
	"./portfolios/aerialportfolio/image12.jpg": "./src/assets/portfolios/aerialportfolio/image12.jpg",
	"./portfolios/aerialportfolio/image13.jpg": "./src/assets/portfolios/aerialportfolio/image13.jpg",
	"./portfolios/aerialportfolio/image2.jpg": "./src/assets/portfolios/aerialportfolio/image2.jpg",
	"./portfolios/aerialportfolio/image3.jpeg": "./src/assets/portfolios/aerialportfolio/image3.jpeg",
	"./portfolios/aerialportfolio/image4.jpg": "./src/assets/portfolios/aerialportfolio/image4.jpg",
	"./portfolios/aerialportfolio/image5.png": "./src/assets/portfolios/aerialportfolio/image5.png",
	"./portfolios/aerialportfolio/image6.jpg": "./src/assets/portfolios/aerialportfolio/image6.jpg",
	"./portfolios/aerialportfolio/image7.jpg": "./src/assets/portfolios/aerialportfolio/image7.jpg",
	"./portfolios/aerialportfolio/image8.jpg": "./src/assets/portfolios/aerialportfolio/image8.jpg",
	"./portfolios/aerialportfolio/image9.jpg": "./src/assets/portfolios/aerialportfolio/image9.jpg",
	"./portfolios/aerialsurveyingPortfolio/image1.jpg": "./src/assets/portfolios/aerialsurveyingPortfolio/image1.jpg",
	"./portfolios/aerialsurveyingPortfolio/image2.jpg": "./src/assets/portfolios/aerialsurveyingPortfolio/image2.jpg",
	"./portfolios/aerialsurveyingPortfolio/image3.jpeg": "./src/assets/portfolios/aerialsurveyingPortfolio/image3.jpeg",
	"./portfolios/aerialsurveyingPortfolio/image4.png": "./src/assets/portfolios/aerialsurveyingPortfolio/image4.png",
	"./portfolios/aerialsurveyingPortfolio/image5.jpg": "./src/assets/portfolios/aerialsurveyingPortfolio/image5.jpg",
	"./portfolios/aerialsurveyingPortfolio/image6.jpg": "./src/assets/portfolios/aerialsurveyingPortfolio/image6.jpg",
	"./portfolios/aerialsurveyingPortfolio/image7.png": "./src/assets/portfolios/aerialsurveyingPortfolio/image7.png",
	"./portfolios/agriculturePortfolio/image1.jpg": "./src/assets/portfolios/agriculturePortfolio/image1.jpg",
	"./portfolios/agriculturePortfolio/image2.png": "./src/assets/portfolios/agriculturePortfolio/image2.png",
	"./portfolios/agriculturePortfolio/image3.png": "./src/assets/portfolios/agriculturePortfolio/image3.png",
	"./portfolios/agriculturePortfolio/image4.jpg": "./src/assets/portfolios/agriculturePortfolio/image4.jpg",
	"./portfolios/agriculturePortfolio/image5.jpg": "./src/assets/portfolios/agriculturePortfolio/image5.jpg",
	"./portfolios/agriculturePortfolio/image6.jpg": "./src/assets/portfolios/agriculturePortfolio/image6.jpg",
	"./portfolios/constructionPortfolio/image1.jpg": "./src/assets/portfolios/constructionPortfolio/image1.jpg",
	"./portfolios/constructionPortfolio/image2.jpg": "./src/assets/portfolios/constructionPortfolio/image2.jpg",
	"./portfolios/constructionPortfolio/image3.jpg": "./src/assets/portfolios/constructionPortfolio/image3.jpg",
	"./portfolios/constructionPortfolio/image4.jpg": "./src/assets/portfolios/constructionPortfolio/image4.jpg",
	"./portfolios/constructionPortfolio/image5.jpg": "./src/assets/portfolios/constructionPortfolio/image5.jpg",
	"./portfolios/constructionPortfolio/image6.jpg": "./src/assets/portfolios/constructionPortfolio/image6.jpg",
	"./portfolios/constructionPortfolio/image7.jpg": "./src/assets/portfolios/constructionPortfolio/image7.jpg",
	"./portfolios/constructionPortfolio/image8.jpg": "./src/assets/portfolios/constructionPortfolio/image8.jpg",
	"./portfolios/homepagePortfolio/image1.jpg": "./src/assets/portfolios/homepagePortfolio/image1.jpg",
	"./portfolios/homepagePortfolio/image10.jpg": "./src/assets/portfolios/homepagePortfolio/image10.jpg",
	"./portfolios/homepagePortfolio/image11.jpg": "./src/assets/portfolios/homepagePortfolio/image11.jpg",
	"./portfolios/homepagePortfolio/image12.jpg": "./src/assets/portfolios/homepagePortfolio/image12.jpg",
	"./portfolios/homepagePortfolio/image13.jpg": "./src/assets/portfolios/homepagePortfolio/image13.jpg",
	"./portfolios/homepagePortfolio/image14.jpg": "./src/assets/portfolios/homepagePortfolio/image14.jpg",
	"./portfolios/homepagePortfolio/image15.jpg": "./src/assets/portfolios/homepagePortfolio/image15.jpg",
	"./portfolios/homepagePortfolio/image16.webp": "./src/assets/portfolios/homepagePortfolio/image16.webp",
	"./portfolios/homepagePortfolio/image17.jpg": "./src/assets/portfolios/homepagePortfolio/image17.jpg",
	"./portfolios/homepagePortfolio/image2.jpg": "./src/assets/portfolios/homepagePortfolio/image2.jpg",
	"./portfolios/homepagePortfolio/image3.jpg": "./src/assets/portfolios/homepagePortfolio/image3.jpg",
	"./portfolios/homepagePortfolio/image4.jpg": "./src/assets/portfolios/homepagePortfolio/image4.jpg",
	"./portfolios/homepagePortfolio/image5.jpg": "./src/assets/portfolios/homepagePortfolio/image5.jpg",
	"./portfolios/homepagePortfolio/image6.png": "./src/assets/portfolios/homepagePortfolio/image6.png",
	"./portfolios/homepagePortfolio/image7.jpg": "./src/assets/portfolios/homepagePortfolio/image7.jpg",
	"./portfolios/homepagePortfolio/image8.jpg": "./src/assets/portfolios/homepagePortfolio/image8.jpg",
	"./portfolios/homepagePortfolio/image9.jpg": "./src/assets/portfolios/homepagePortfolio/image9.jpg",
	"./portfolios/industrialInspectionPortfolio/image1.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image1.jpg",
	"./portfolios/industrialInspectionPortfolio/image10.jpeg": "./src/assets/portfolios/industrialInspectionPortfolio/image10.jpeg",
	"./portfolios/industrialInspectionPortfolio/image11.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image11.jpg",
	"./portfolios/industrialInspectionPortfolio/image2.webp": "./src/assets/portfolios/industrialInspectionPortfolio/image2.webp",
	"./portfolios/industrialInspectionPortfolio/image3.webp": "./src/assets/portfolios/industrialInspectionPortfolio/image3.webp",
	"./portfolios/industrialInspectionPortfolio/image4.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image4.jpg",
	"./portfolios/industrialInspectionPortfolio/image5.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image5.jpg",
	"./portfolios/industrialInspectionPortfolio/image6.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image6.jpg",
	"./portfolios/industrialInspectionPortfolio/image7.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image7.jpg",
	"./portfolios/industrialInspectionPortfolio/image8.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image8.jpg",
	"./portfolios/industrialInspectionPortfolio/image9.jpg": "./src/assets/portfolios/industrialInspectionPortfolio/image9.jpg",
	"./portfolios/rooftopinspectionportfolio/image1.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image1.jpg",
	"./portfolios/rooftopinspectionportfolio/image2.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image2.jpg",
	"./portfolios/rooftopinspectionportfolio/image3.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image3.jpg",
	"./portfolios/rooftopinspectionportfolio/image4.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image4.jpg",
	"./portfolios/rooftopinspectionportfolio/image5.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image5.jpg",
	"./portfolios/rooftopinspectionportfolio/image6.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image6.jpg",
	"./portfolios/rooftopinspectionportfolio/image7.jpeg": "./src/assets/portfolios/rooftopinspectionportfolio/image7.jpeg",
	"./portfolios/rooftopinspectionportfolio/image8.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image8.jpg",
	"./portfolios/rooftopinspectionportfolio/image9.jpg": "./src/assets/portfolios/rooftopinspectionportfolio/image9.jpg",
	"./roof-service-1.jpg": "./src/assets/roof-service-1.jpg",
	"./roof-service-2.jpg": "./src/assets/roof-service-2.jpg",
	"./roof-service-3.jpg": "./src/assets/roof-service-3.jpg",
	"./roof-service-3u.jpg": "./src/assets/roof-service-3u.jpg",
	"./service1-bg.jpg": "./src/assets/service1-bg.jpg",
	"./service2-bg.jpg": "./src/assets/service2-bg.jpg",
	"./service3-bg.jpg": "./src/assets/service3-bg.jpg",
	"./service4-bg.jpg": "./src/assets/service4-bg.jpg",
	"./service5-bg.jpg": "./src/assets/service5-bg.jpg",
	"./service6-bg.jpg": "./src/assets/service6-bg.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";